import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Message, TableData } from '../models/domain';
import { Account, AccountTransaction, AccountTransactionEntry, BalanceSheetReport, FinanceReports, Journal, Ledger, Payment, ProfitAndLossReport, Transaction, Voucher, VoucherContext, VoucherEntry } from '../models/finance';

@Injectable({
  providedIn: 'root',
})
export class FinanceService {
  constructor(private httpClient: HttpClient) { }

  //ACCOUNTS API'S
  public createAccount(account: Account): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/account', account);
  }

  public getAccount(id: number): Observable<Account> {
    return this.httpClient.get<Account>(`/api/finance/v1/account/${id}`);
  }

  public getAccounts(company: number, type?: string, disabled?: boolean,subAccount?:boolean): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`/api/finance/v1/accounts?company=${company}`, { params: { ...type && { type }, ...(disabled != null && { disabled }), ...subAccount && { subAccount } } })
  }

  public getAccountsByPage (company: number, page: number, size: number,mandatory?: boolean,type?: string, disabled?: boolean,
    fromDate?: string,
    toDate?: string): Observable<TableData> {
    return this.httpClient.get<TableData>('/api/finance/v1/accounts/page', { params: { ...(company && { company }), ...(page > -1 && { page }), ...(size > -1 && { size }), ...mandatory && { mandatory }, ...type && { type }, ...(disabled != null && { disabled }), ...(fromDate && { fromDate }), ...(toDate && { toDate }) } });
  }

  public updateAccount(id: number, account: Account): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/account/${id}`, account);
  }

  public deleteAccount(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/account/${id}`);
  }

  public getCategory(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/finance/v1/category')
  }

  public getNature(): Observable<string[]> {
    return this.httpClient.get<string[]>('/api/finance/v1/nature')
  }

  public toggleAccountStatus(account: Account): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/account/${account.id}`, account);
  }

  public checkPAdminAndAccountant(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/finance/v1/account/check-edit/${id}`);
  }
  //CASHBOOK API'S
  public createJournal(journal: Journal): Observable<Journal> {
    return this.httpClient.post<Journal>('/api/finance/v1/journal', journal);
  }

  public getJournal(id: number): Observable<Journal> {
    return this.httpClient.get<Journal>(`/api/finance/v1/journal/${id}`);
  }

  public getJournals(startDate?: string, endDate?: string, disabled?: boolean): Observable<Journal[]> {
    return this.httpClient.get<Journal[]>(`/api/finance/v1/journals`, { params: { ...startDate && { startDate }, ...endDate && { endDate }, ...(disabled != null && { disabled }) } })
  }

  public updateJournal(id: number, journal: Journal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/journal/${id}`, journal);
  }

  public deleteJournal(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/journal/${id}`);
  }
  public toggleJournalStatus(journal: Journal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/journal/${journal.id}`, journal);
  }
  //Transation API'S
  public createTransation(transation: Transaction[]): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction', transation);
  }

  public getTransation(id: number): Observable<Transaction> {
    return this.httpClient.get<Transaction>(`/api/finance/v1/transaction/${id}`);
  }

  public getTransations(journalId: number): Observable<Transaction[]> {
    return this.httpClient.get<Transaction[]>(`/api/finance/v1/transactions?journalId=${journalId}`)
  }

  public updateTransation(transation: Transaction[]): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction`, transation);
  }

  public deleteTransation(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }

  public toggleTransationStatus(transation: Transaction): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${transation.id}`, transation);
  }
  public deleteJornalEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }

  // Payment API's
  public createPayment(payment: Payment): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/payment', payment);
  }

  public getPayment(id: number): Observable<Payment> {
    return this.httpClient.get<Payment>(`/api/finance/v1/payment/${id}`);
  }

  public getPayments(journalId: number): Observable<Payment[]> {
    return this.httpClient.get<Payment[]>(`/api/finance/v1/payments?journalId=${journalId}`);
  }

  public updatePayment(id: number, payment: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/payment/${id}`, payment);
  }

  public deletePayment(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/payment/${id}`);
  }

  public togglePaymentStatus(payment: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/payment/${payment.id}`, payment);
  }

  // Journel

  public getJournels(
    company: number,
    startDate?: string,
    endDate?: string
  ): Observable<Journal[]> {
    if (company)
      return this.httpClient.get<Journal[]>(
        `/api/finance/v1/journal?company=${company}`
      );
    else {
      return this.httpClient.get<Journal[]>(`/api/finance/v1/journal`);
    }
  }
  public getJournel(id: number): Observable<Journal> {
    return this.httpClient.get<Journal>(`/api/finance/v1/journal/${id}`);
  }
  // public createJournal(journal: Journal): Observable<Journal> {
  //   return this.httpClient.post<Journal>('/api/finance/v1/journal', journal);
  // }
  // public updateJournal(id: number, journal: Journal): Observable<Journal> {
  //   return this.httpClient.put<Journal>(
  //     `/api/finance/v1/journal/${id}`,
  //     journal
  //   );
  // }
  public deleteJournel(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/finance/v1/journal/${id}`);
  }
  public deleteJournelEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/journal-entry/${id}`);
  }
  //ledger
  public getledgers(company: number, acc: number): Observable<Ledger[]> {
    if (company && acc) {
      return this.httpClient.get<Ledger[]>(
        `/api/finance/v1/ledger/${acc}?company=${company}`
      );
    }
  }
  public getAllLedgers(company: number): Observable<Map<string, any[]>> {
    if (company)
      return this.httpClient.get<Map<string, any[]>>(
        `/api/finance/v1/ledger?company=${company}`
      );
    // else {
    //   return this.httpClient.get<Map<string, string>>(`/api/finance/v1/ledger`);
    // }
  }

  // FINANCE REPORT

  public getFinanceReport(type: string, startDate: string, endDate: string): Observable<FinanceReports[]> {
    return this.httpClient.get<FinanceReports[]>(`/api/finance/v1/finance-report`, { params: { type, startDate, endDate } })
  }

  // ACCOUNT TRANSACTION API's
  public createAccountTransaction(accountTransaction: AccountTransaction): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction', accountTransaction);
  }

  public getAccountTransaction(id: number): Observable<AccountTransaction> {
    return this.httpClient.get<AccountTransaction>(`/api/finance/v1/transaction/${id}`);
  }

  public getAccountTransactions(fromDate?: string, toDate?: string, disabled?: boolean): Observable<AccountTransaction[]> {
    return this.httpClient.get<AccountTransaction[]>(`/api/finance/v1/transactions`, { params: { ...fromDate && { fromDate }, ...toDate && { toDate }, ...(disabled != null && { disabled }) } });
  }

  public getAccountTransactionsByPge (page: number, size: number, disabled?: boolean,
    fromDate?: string,
    toDate?: string): Observable<TableData> {
    return this.httpClient.get<TableData>('/api/finance/v1/transactions/page', { params: { ...(page > -1 && { page }), ...(size > -1 && { size }), ...(disabled != null && { disabled }), ...(fromDate && { fromDate }), ...(toDate && { toDate }) } });
  }

  public updateAccountTransaction(id: number, accountTransaction: AccountTransaction): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${id}`, accountTransaction);
  }

  public deleteAccountTransaction(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction/${id}`);
  }

  public toggleAccountTransaction(accountTransaction: Payment): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction/${accountTransaction.id}`, accountTransaction);
  }

  // ACCOUNT TRANSACTION API's
  public createAccountTransactionEntry(accountTransactionEntry: AccountTransactionEntry): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/transaction-entry', accountTransactionEntry);
  }

  public getAccountTransactionEnrty(id: number): Observable<AccountTransactionEntry> {
    return this.httpClient.get<AccountTransactionEntry>(`/api/finance/v1/transaction-entry/${id}`);
  }

  public getAccountTransactionEntries(transactionId: number): Observable<AccountTransactionEntry[]> {
    return this.httpClient.get<AccountTransactionEntry[]>(`/api/finance/v1/transaction-entries?transactionId=${transactionId}`);
  }

  public updateAccountTransactionEntry(id: number, accountTransactionEntry: AccountTransactionEntry): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/transaction-entry/${id}`, accountTransactionEntry);
  }

  public deleteAccountTransactionEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction-entry/${id}`);
  }

  public deleteAllTransactionEntries(ids: number[]): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/transaction-entries`, { params: { ids } });
  }

  //LEDGER REPORT API's

  public getLedgerReportByPge (page: number, size: number, disabled?: boolean, type?:string, fromDate?: string, toDate?: string): Observable<TableData> {
    return this.httpClient.get<TableData>('/api/finance/v1/ledger-report', { params: { ...(page > -1 && { page }), ...(size > -1 && { size }), ...(disabled != null && { disabled }), ...(type && { type }), ...(fromDate && { fromDate }), ...(toDate && { toDate }) } });
  }
  //VOUCHER API'S
  public createVoucher(voucher: Voucher): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/voucher', voucher);
  }

  public getVoucher(id: number): Observable<Voucher> {
    return this.httpClient.get<Voucher>(`/api/finance/v1/voucher/${id}`);
  }

  public getVouchers(page: number, size: number, fromDate: string, toDate: string, voucherType?: string): Observable<TableData> {
    return this.httpClient.get<TableData>(`/api/finance/v1/vouchers/page`, { params: { page, size, fromDate, toDate, ...(voucherType && { voucherType }) } });
  }

  public updateVoucher(id: number, voucher: Voucher): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/voucher/${id}`, voucher);
  }

  public deleteVoucher(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/voucher/${id}`);
  }

  public getVoucherType(): Observable<String[]> {
    return this.httpClient.get<string[]>(`/api/finance/v1/voucher-type`);
  }

  public getVoucherStatus(id: number, status: string): Observable<Message> {
    return this.httpClient.patch<Message>(`/api/finance/v1/voucher-status/${id}`, {}, { params: { status } });
  }


  //VOUCHER ENTRIES API'S
  public createVoucherEntry(voucherEntry: VoucherEntry): Observable<Message> {
    return this.httpClient.post<Message>('/api/finance/v1/voucher-entry', voucherEntry);
  }

  public getVoucherEntry(id: number): Observable<VoucherEntry> {
    return this.httpClient.get<VoucherEntry>(`/api/finance/v1/voucher-entry/${id}`);
  }

  public getVoucherEntries(voucherId: number): Observable<VoucherEntry[]> {
    return this.httpClient.get<VoucherEntry[]>(`/api/finance/v1/voucher-entries`, { params: { voucherId } });
  }

  public updateVoucherEntry(voucherEntry: VoucherEntry[]): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/voucher-entry`, voucherEntry);
  }

  public deleteVoucherEntry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/finance/v1/voucher-entry/${id}`);
  }

  public uploadVoucherFile(voucherEntryId: number, file: FormData): Observable<Message> {
    return this.httpClient.put<Message>(`/api/finance/v1/voucher-entries/upload`, file, { params: { voucherEntryId } });
  }


  //PF REPORT API's
  public getProfitAndLossReport(
    fromDate?: string,
    toDate?: string
  ): Observable<ProfitAndLossReport> {
    return this.httpClient.get<ProfitAndLossReport>('/api/finance/v1/profit-loss-report', {
      params: { ...(fromDate && { fromDate }), ...(toDate && { toDate }) }
    });
  }
    //VOUCHER CONTEXT API'S
    public getFinancialYears(): Observable<Map<string, string>> {
      return this.httpClient.get<Map<string, string>>(`/api/context/v1/financial-year`);
    }

    //BALANCE SHEET REPORT API'S
    public getBalanceSheetReport(fromDate: string, toDate: string): Observable<BalanceSheetReport> {
      return this.httpClient.get<BalanceSheetReport>('/api/finance/v1/balance-sheet-report', {params: {fromDate, toDate}});
    }
}
